import * as types from './actionTypes';

export function addCurrentCaseNumber(casenumber) {
  return {
    type: types.ADD_CASE_NUMBER,
    addCurrentCaseNumber: casenumber,
  };
}

